import React, { Component } from 'react'
import { Container, Row, Col} from 'react-bootstrap'
import Footer from './Footer'
import HeaderTop from './HeaderTop'
import SideNavTop from './SideNavTop'
import '../Accueil.css'

class Sauvetage extends Component {
state = {
    redirect:false,
    search: ''
    }

handleCHange = event => {
    const { name, value } = event.target
    this.setState({ [name]: value })
}

setRedirect = () => {
    this.setState({
      redirect: true
    })
  }
  
  handleSubmitFacebbok = () => {
    if (this.state.redirect) {
        window.location.href = "https://www.facebook.com/clubCAPN/";
    }
  }

handleSubmit = event => {
    //on gere le form
    event.preventDefault()
    this.props.history.push(`/recherche/${this.state.search}`);
}

render () {  
    return (
    <>
        <Container fluid>
        <Row>
            <SideNavTop/>
            <Col lg={10} md={12} sm={12} xs={12} id="page-content-wrapper" className="nopadding">
              <HeaderTop
                handleSubmit={this.handleSubmit}
                handleCHange={this.handleCHange}
                handleSubmitFacebbok={this.handleSubmitFacebbok}
                setRedirect={this.setRedirect}
              />

                <Col lg={12} md={12} sm={12} xs={12} className="nopadding">
                    <Row>
                    <Col lg={12} md={12} sm={12} xs={12} className="nopadding">
                    <div className="histoire-content">
                        <h1><span>FORMATIONS</span></h1>   
                        <h2>Médaille de bronze</h2>
                        <p className="pCenter"> 
                            <strong>Pré-requis:</strong> <br />
                            - 13 ans et +<br />
                            -Avoir les aptitudes de natation du niveau junior 10 ou équivalence.<br />
                                <strong>Coût:</strong> 190 $ <br />
                                <i>* Le Coût du cours ne comprends pas le manuel requis pour la formation et le masque de poche.</i><br /><br />
                            
                                <strong>Manuel obligatoire:</strong> 60 $. Ce même manuel servira aussi à la formation Croix de Bronze.<br /><br />
                        </p>
                        <h2>Croix de bronze</h2>
                        <p className="pCenter"> 
                            <strong>Pré-requis:</strong> <br />
                            - 13 ans et +<br />
                            - Avoir réussi la formation médaille de bronze<br />
                                <strong>Coût:</strong> 190 $ <br />
                        </p>
                        <h2>Médaille de bronze et croix de bronze combinés</h2>
                        <p className="pCenter"> 
                            <strong>Pré-requis:</strong> <br />
                            - 13 ans et +<br />
                            - Avoir les aptitudes de natation du niveau junior 10 ou équivalence.<br />
                                <strong>Coût:</strong> 350 $ <br />
                                <i>* Le Coût du cours ne comprends pas le manuel requis pour la formation.</i><br /><br />
                            
                                <strong>Manuel obligatoire:</strong> 60 $. Ce même manuel servira aussi à la formation Croix de Bronze.<br /><br />
                        </p>
                        <h2>Premiers Soins Général</h2>
                        <p className="pCenter"> 
                            <strong>Pré-requis:</strong> <br />
                            AUCUN<br />
                                <strong>Coût:</strong> 130 $ (Manuel inclu) <br />
                        </p>
                        <h2>Sauveteur National</h2>
                        <p className="pCenter"> 
                            <strong>Pré-requis:</strong> <br />
                            - 16 ans et +<br />
                            - Avoir réussi la formation croix de bronze<br />
                            - Avoir réussi la formation de premiers soins général<br />
                            <strong>Coût:</strong> 275 $ <br />
                            <i>* Le Coût du cours ne comprends pas le manuel requis pour la formation.</i><br /><br />
                            
                            <strong>Manuel obligatoire:</strong> 60 $. Ce même manuel servira aussi à la formation Croix de Bronze.<br /><br />
                        </p>
                        <h2>Moniteur en sécurtité aquatique</h2>
                        <p className="pCenter"> 
                            <strong>Pré-requis:</strong> <br />
                            - 15 ans et +<br />
                            - Avoir les aptitudes de natation du niveau junior 10 ou équivalence.<br />
                            - Avoir réussi la formation croix de bronze<br />
                                <strong>Coût:</strong> 385 $ (Manuel, guide pratique et accèes pour la formation en ligne inclus) <br />                            
                        </p>
                        <h2>Moniteur d'aquaforme</h2>
                        <p className="pCenter"> 
                            <strong>Pré-requis:</strong> <br />
                            - 15 ans et +<br />
                            - Avoir les aptitudes de natation du niveau junior 10 ou équivalence.<br />
                                <strong>Coût:</strong> 175 $ (Manuel, guide pratique inclus) <br />
                        </p>
                    </div>

                    </Col>
                    </Row>
                </Col>


            <Col lg={12} md={12} sm={12} xs={12} className="nopadding">
               <Footer />
            </Col>
            </Col>
        </Row>
        </Container>
    </>
    )
}
}

export default Sauvetage
